'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.is-nan");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.filter");

var integerRegex = /^\d+$/;

function deepUnique(array) {
  return array.sort().filter(function (element, index) {
    return JSON.stringify(element) !== JSON.stringify(array[index - 1]);
  });
}

exports.parse = function (string) {
  return deepUnique(string.split(',').map(function (part) {
    var result = {};
    part.trim().split(/\s+/).forEach(function (element, index) {
      if (index === 0) {
        result.url = element;
        return;
      }

      var value = element.slice(0, element.length - 1);
      var postfix = element[element.length - 1];
      var integerValue = parseInt(value, 10);
      var floatValue = parseFloat(value);

      if (postfix === 'w' && integerRegex.test(value)) {
        result.width = integerValue;
      } else if (postfix === 'h' && integerRegex.test(value)) {
        result.height = integerValue;
      } else if (postfix === 'x' && !Number.isNaN(floatValue)) {
        result.density = floatValue;
      } else {
        throw new Error("Invalid srcset descriptor: ".concat(element));
      }
    });
    return result;
  }));
};

exports.stringify = function (array) {
  return _toConsumableArray(new Set(array.map(function (element) {
    if (!element.url) {
      throw new Error('URL is required');
    }

    var result = [element.url];

    if (element.width) {
      result.push("".concat(element.width, "w"));
    }

    if (element.height) {
      result.push("".concat(element.height, "h"));
    }

    if (element.density) {
      result.push("".concat(element.density, "x"));
    }

    return result.join(' ');
  }))).join(', ');
};